var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup156(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(-456 -3175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 67,
    height: 67,
    rx: 15,
    transform: "translate(456 3175)",
    fill: "#f6f6fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(471.981 3191.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "market_research",
    "data-name": "market research"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M23.327,3.993a13.641,13.641,0,0,0-19.28,0C-7.525,16.246,8.029,34.166,21.753,24.62L24.019,26.9l2.935-2.943-2.266-2.266a13.638,13.638,0,0,0-1.362-17.7Z",
    transform: "translate(0 -0.004)",
    fill: "#fa3f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M0,0H7.12V3.558H0Z",
    transform: "translate(22.968 27.937) rotate(-45)",
    fill: "#d7dcf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M23.921,18.861,20.34,15.272l-5.028,5.041,3.581,3.574a3.23,3.23,0,0,0,4.586,0,3.341,3.341,0,0,0,.441-5.026Z",
    transform: "translate(10.179 10.147)",
    fill: "#e5e9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M6.128,17.335a9.865,9.865,0,0,0,13.29-9.143h-9.8Z",
    transform: "translate(4.073 5.44)",
    fill: "#d5dbf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M5.187,5.172A9.846,9.846,0,0,0,8.635,21.257l3.486-9.143V2.292a9.771,9.771,0,0,0-6.934,2.88Z",
    transform: "translate(1.566 1.518)",
    fill: "#fcb65f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M15.161,4.317a9.2,9.2,0,0,0-.849-.739l-6.09,7.681h9.8a9.787,9.787,0,0,0-2.865-6.942Z",
    transform: "translate(5.465 2.373)",
    fill: "#bbdff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M8.222,2.292v9.822l6.09-7.681a9.774,9.774,0,0,0-6.09-2.141Z",
    transform: "translate(5.465 1.518)",
    fill: "#36a6ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M12.748,12.707a4.087,4.087,0,1,1,0-5.78A4.087,4.087,0,0,1,12.748,12.707Z",
    transform: "translate(3.834 3.805)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup156);
export default __webpack_public_path__ + "static/media/Group 156.c96a36836875138cc9f412b5033d2278.svg";
export { ForwardRef as ReactComponent };